import { useQuery, UseQueryOptions, UseQueryResult } from 'react-query';
import { EmailsConfiguration } from '~/pages/Portal/Settings/EmailControls';
import { getEmailConfigurationByType } from '~/services/EmailConfiguration';

export function useEmailConfigurationByType(
  tipoConfiguracao: number,
): UseQueryResult<EmailsConfiguration> {
  return useQuery<EmailsConfiguration>(
    ['emailConfigurationByType', tipoConfiguracao],
    () => getEmailConfigurationByType(tipoConfiguracao),
    {
      staleTime: 1000 * 60 * 10, // 10 minutes
    },
  );
}
